import React from 'react';

export const isEDMode =
    typeof window !== 'undefined' ? window.location.href.indexOf('ed=1') > 0 : false;
export const mobileMedia = '(min-width: 0px) and (max-width: 1200px)';
export const tabletMedia = '(min-width: 768px) and (max-width: 1200px)';

export const isMobile = (media = false) => {
    if (typeof window !== 'undefined') {
        return window.matchMedia(media || mobileMedia).matches;
    }

    return true;
};

export const isTablet = () => {
    if (typeof window !== 'undefined') {
        return window.matchMedia(tabletMedia).matches;
    }

    return true;
};

export const bounds = elem => {
    const rect = elem.getBoundingClientRect();

    return {
        top: rect.top,
        left: rect.left,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height,
    };
};

export const getWinSize = () => {
    if (typeof window !== 'undefined') {
        const w = window;
        const d = document;
        const e = d.documentElement;
        const g = d.getElementsByTagName('body')[0];
        const x = w.innerWidth || e.clientWidth || g.clientWidth;
        const y = w.innerHeight || e.clientHeight || g.clientHeight;

        return { width: x, height: y };
    }

    return { width: 0, height: 0 };
};

export const inViewport = (elem, entireBox = false, _xOffset = 0, _yOffset = 0) => {
    if (typeof window !== 'undefined') {
        const bds = bounds(elem);
        const doc = getWinSize();

        if (!entireBox) {
            return (
                bds.top >= 0 &&
                bds.left >= 0 &&
                bds.top <= doc.height &&
                bds.left <= doc.width
            );
        } else {
            const topLimit = bds.top - doc.height;
            const bottomLimit = bds.top + bds.height;
            const leftLimit = bds.left - doc.width;
            const rightLimit = bds.left + bds.width;

            return topLimit <= 0 && bottomLimit >= 0 && leftLimit <= 0 && rightLimit >= 0;
        }
    }

    return false;
};

const timeoutDebounce = {};
export const debounce = (name, func, wait, immediate) => {
    return function () {
        const context = this;
        const args = arguments;

        const later = () => {
            timeoutDebounce[name] = null;

            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeoutDebounce[name];

        clearTimeout(timeoutDebounce[name]);

        timeoutDebounce[name] = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
};

export const getOS = () => {
    let OSName = 'unknown-os';

    if (navigator.userAgent.includes('Win')) OSName = 'win';
    if (navigator.userAgent.includes('Mac')) OSName = 'mac';
    if (navigator.userAgent.includes('X11')) OSName = 'unix';
    if (navigator.userAgent.includes('iPhone')) OSName = 'ios';
    if (navigator.userAgent.includes('iPad')) OSName = 'ios';
    if (navigator.userAgent.includes('Linux')) OSName = 'linux';

    return OSName;
};

export const offset = elem => {
    if (typeof window !== 'undefined') {
        const rect = bounds(elem);
        const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    return { top: 0, left: 0 };
};

export const isExactPath = path => {
    if (typeof window !== 'undefined') {
        return window.location.pathname === path;
    }
};

export const focusLoop = (e, selector) => {
    const TAB_KEY_CODE = 9;
    const tabPressed = e.key === 'Tab' || e.keyCode === TAB_KEY_CODE;

    if (!tabPressed) return;

    const elems = document.querySelectorAll(selector);

    if (elems?.length) {
        const firstElem = elems[0];
        const lastElem = elems[elems.length - 1];

        if (!Array.from(elems).includes(document.activeElement)) {
            firstElem.focus();
        }

        if (e.shiftKey) {
            if (document.activeElement === firstElem) {
                lastElem.focus();
                e.preventDefault();
            }
        } else {
            if (document.activeElement === lastElem) {
                firstElem.focus();
                e.preventDefault();
            }
        }
    }
};

export const getCookieByName = cookieName => {
    const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(cookieName + '='));
    if (cookieValue === undefined) {
        return null;
    }
    return cookieValue.split('=')[1];
};

export const checkSettingsBtns = () => {
    const allowAllBtn = document.body.querySelector('#accept-recommended-btn-handler');
    const targetChecked = document.querySelector('#ot-group-id-C0002').checked;
    const performanceChecked = document.querySelector('#ot-group-id-C0004').checked;

    if (targetChecked && performanceChecked) {
        allowAllBtn.style.display = 'none';
    } else {
        allowAllBtn.style.display = 'inline-block';
    }
};

export const getUrlParameter = param => {
    param = param.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
    const results = regex.exec(window.location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const scrollToSection = (selector, isSmooth, withOffset = false) => {
    const el = document.querySelector(selector);
    if (el) {
        if (!withOffset) {
            el.scrollIntoView({
                behavior: isSmooth ? 'smooth' : 'auto',
            });
        } else {
            // 151(106) is the height of the sticky header on mobile(desktop) devices
            const offsetMob = 151;
            const offsetDesk = 106;
            const offsetY = isMobile() ? offsetMob : offsetDesk; 
            const elementPosition =
                el.getBoundingClientRect().top + window.scrollY - offsetY;

            window.scrollTo({
                top: elementPosition,
                behavior: isSmooth ? 'smooth' : 'auto',
            });
        }
    }
};

export const openCookieModal = () => {
    if (typeof window !== 'undefined' && 'OneTrust' in window) {
        window.OneTrust.ToggleInfoDisplay();
    }
};

const applyMobileContainerStyles = (container, height) => {
    container.style.position = 'absolute';
    const elements = document.querySelectorAll(
        'html, body, #___gatsby, #gatsby-focus-wrapper'
    );
    elements.forEach(el => {
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('height', height + 'px', 'important');
        el.style.setProperty('max-height', height + 'px', 'important');
    });
};

const heightOffsetVal = 50;
const totalHeightOffsetVal = 250;

const handleCookiePcCenterHeight = () => {
    const container = document.querySelector('#onetrust-pc-sdk');
    if (!container || container?.style.display === 'none') return;

    const header = document.querySelector('.ot-pc-header');
    const pcContent = document.querySelector('#ot-pc-content');
    const footer = document.querySelector('.ot-pc-footer');

    if (!header || !pcContent || !footer) return;

    pcContent.style.overflow = 'visible';
    pcContent.style.height = 'max-content';
    const height = header.offsetHeight + pcContent.offsetHeight + footer.offsetHeight + heightOffsetVal;
    
    container.style.setProperty('height', height + 'px', 'important');
    container.style.setProperty('max-height', height + 'px', 'important');

    if (isMobile()) {
        applyMobileContainerStyles(container, height);
    }
};

const handleCookieSettingsAllOpen = () => {
    const container = document.querySelector('#onetrust-pc-sdk');
    if (!container || container?.style.display === 'none') return;

    const filtersSection = document.querySelector('#ot-pc-lst');
    const filters = document.querySelector('#ot-lst-cnt');
    const height = document.querySelector('#ot-lst-cnt > .ot-sdk-row')?.offsetHeight;

    if (!filtersSection || !filters || !height) return;

    const contentHeight = height + heightOffsetVal;
    const totalHeight = height + totalHeightOffsetVal;

    filters.style.setProperty('height', contentHeight + 'px', 'important');
    filters.style.setProperty('max-height', 'unset', 'important');
    filtersSection.style.setProperty('height', contentHeight + 'px', 'important');
    filtersSection.style.setProperty('max-height', 'unset', 'important');
    container.style.setProperty('height', totalHeight + 'px', 'important');
    container.style.setProperty('min-height', totalHeight + 'px', 'important');

    if (isMobile()) {
        container.style.setProperty('max-height', totalHeight + 'px', 'important');
        container.style.setProperty('min-height', '100vh', 'important');
        applyMobileContainerStyles(container, totalHeight);
        
        const elements = document.querySelectorAll(
            'html, body, #___gatsby, #gatsby-focus-wrapper'
        );
        elements.forEach(el => {
            el.style.setProperty('min-height', '100vh', 'important');
        });
    }
};

const handleDefaultMobileView = () => {
    if (!isMobile()) return;

    const elements = document.querySelectorAll(
        'html, body, #___gatsby, #gatsby-focus-wrapper'
    );
    elements.forEach(el => {
        el.style.setProperty('overflow', 'hidden', 'important');
        el.style.setProperty('height', '100vh', 'important');
        el.style.setProperty('min-height', '100vh', 'important');
        el.style.setProperty('max-height', '100vh', 'important');
    });
};

export const ssCookieModalFullHeightFilter = () => {
    if (window.location.href.includes('cookiePcCenterHeight=1')) {
        handleCookiePcCenterHeight();
    } else if (window.location.href.includes('cookie-settings-all-open=1')) {
        handleCookieSettingsAllOpen();
    } else {
        handleDefaultMobileView();
    }
};

export const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
};

export const extractTextFromElement = element => {
    if (element?.props && element?.props?.children) {
        if (typeof element.props.children === 'string') {
            return element.props.children;
        } else if (Array.isArray(element.props.children)) {
            const textContentArray = element.props.children.map(child => {
                if (typeof child === 'string') {
                    return child;
                } else if (typeof child === 'object' && child !== null) {
                    return extractTextFromElement(child);
                } else {
                    return '';
                }
            });

            return textContentArray.join(' ');
        } else {
            return '';
        }
    } else {
        return element;
    }
};

// React hook for viewport width detection
export const useViewportWidth = (breakpoint = 1280) => {
    const [isViewportSmall, setIsViewportSmall] = React.useState(false);

    React.useEffect(() => {
        const checkViewportWidth = () => {
            setIsViewportSmall(window.innerWidth < breakpoint);
        };

        // Check on mount
        checkViewportWidth();

        // Add resize listener
        window.addEventListener('resize', checkViewportWidth);

        // Cleanup
        return () => window.removeEventListener('resize', checkViewportWidth);
    }, [breakpoint]);

    return isViewportSmall;
};

// React hook to detect if viewport is desktop size
export const useIsDesktop = (desktopBreakpoint = 1280) => {
    const [isDesktop, setIsDesktop] = React.useState(false);

    React.useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= desktopBreakpoint);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [desktopBreakpoint]);

    return isDesktop;
};

export const getActiveEnv = (getActualValue = false, maskDevAsStage = true, maskReleaseAsProd = true) => {
	let activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.BUILD_ENV;
	// Checking for value masking.
	if (!getActualValue) {
		if (activeEnv === "dev" && maskDevAsStage) {
			activeEnv = "stage";
		}
		else if (activeEnv === "release" && maskReleaseAsProd) {
			activeEnv = "prod";
		}
		else {
			void 0;
		}
	}
 	return activeEnv;
}